/// <reference types="node"/>
import * as querystring from 'querystring';
import { getURLs, LalaSentry } from '.';
import { validateReturnURLByMap } from './validateReturnURL';
var generateReturnURLHOF = function (returnURLs) { return function (urlQueries) {
    var stringQueries = querystring.stringify(urlQueries.queries);
    var returnUrlParam = urlQueries.returnURL || '';
    var returnURL = validateReturnURLByMap(returnURLs, returnUrlParam) ? returnUrlParam : returnURLs.authenticated;
    if (stringQueries === '')
        return returnURL;
    if (returnURL.includes('?'))
        return "".concat(returnURL, "&").concat(stringQueries);
    return "".concat(returnURL, "?").concat(stringQueries);
}; };
export var getReturnURLFromLALAURLQueries = function (brand, type, env, returnURL, lendiGroupTeamView) {
    var returnURLs = getURLs(brand, type, env, lendiGroupTeamView);
    var generateReturnURL = generateReturnURLHOF(returnURLs);
    return generateReturnURL(returnURL);
};
export var executeReturnURL = function (brand, type, env, returnURL, lendiGroupTeamView) {
    var returnUrl = getReturnURLFromLALAURLQueries(brand, type, env, returnURL, lendiGroupTeamView);
    LalaSentry.logInfo('redirect by executeReturnURL', { returnUrl: returnUrl });
    window.location.assign(returnUrl);
};
//# sourceMappingURL=executeReturnURL.js.map